var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRwarrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5742,
    cy: 29.5742,
    r: 29.5742,
    fill: "#FFFFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3224 31.38C42.9082 30.7942 42.9082 29.8445 42.3224 29.2587L32.7764 19.7127C32.1906 19.1269 31.2409 19.1269 30.6551 19.7127C30.0693 20.2985 30.0693 21.2483 30.6551 21.8341L39.1404 30.3193L30.6551 38.8046C30.0693 39.3904 30.0693 40.3401 30.6551 40.9259C31.2409 41.5117 32.1907 41.5117 32.7764 40.9259L42.3224 31.38ZM17.8828 30.3193L17.8828 31.8193L41.2617 31.8193L41.2617 30.3193L41.2617 28.8193L17.8828 28.8193L17.8828 30.3193Z",
    fill: "#EE3424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwarrow);
export default __webpack_public_path__ + "static/media/rwarrow.53c98ea4a60e0cb40c526466e0c8423d.svg";
export { ForwardRef as ReactComponent };